module.exports = __webpack_public_path__ + "img/039.66dae474.png";